export const BOP_EXPORT_DATA_TYPES = {
  SUMMARY: 'summary',
  DETAIL: 'detail',
  LABOR_COSTS: 'laborCosts',
  UNIT_COSTS: 'unitCosts',
} as const
